// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_3H45","show":"cQuY"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Tooltip/Tooltip.scss
// module id = tFTI
// module chunks = 0